import React, { useRef, useState, useCallback, useEffect } from "react";
import "./WavyMarquee.css";

const WavyMarquee = () => {
    const textPathRef = useRef(null);
    const animateRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [currentOffset, setCurrentOffset] = useState(-32);
    const [isAnimating, setIsAnimating] = useState(true);

    // Función para pausar/reanudar la animación nativa de SVG
    const toggleAnimation = useCallback((play) => {
        if (animateRef.current) {
            if (play) {
                animateRef.current.beginElement();
            } else {
                // Para pausar la animación SVG
                const computedStyle = window.getComputedStyle(animateRef.current);
                if (computedStyle.animationPlayState) {
                    animateRef.current.style.animationPlayState = 'paused';
                }
            }
        }
    }, []);

    const handleMouseDown = useCallback((e) => {
        setIsDragging(true);
        setStartX(e.clientX);
        setIsAnimating(false);
        toggleAnimation(false);
        e.preventDefault();
    }, [toggleAnimation]);

    const handleMouseMove = useCallback((e) => {
        if (!isDragging) return;
        
        const deltaX = startX - e.clientX; // Invertido para dirección natural
        const sensitivity = 0.02;
        const newOffset = currentOffset - (deltaX * sensitivity);
        
        setCurrentOffset(newOffset);
        
        if (textPathRef.current) {
            textPathRef.current.setAttribute("startOffset", newOffset + "%");
        }
        
        setStartX(e.clientX);
    }, [isDragging, startX, currentOffset]);

    const handleMouseUp = useCallback(() => {
        if (isDragging) {
            setIsDragging(false);
            setIsAnimating(true);
            toggleAnimation(true);
        }
    }, [isDragging, toggleAnimation]);

    const handleMouseLeave = useCallback(() => {
        if (isDragging) {
            setIsDragging(false);
            setIsAnimating(true);
            toggleAnimation(true);
        }
    }, [isDragging, toggleAnimation]);

    return (
        <div className="marquee-container">
            <div className="marquee">
                <svg 
                    className="svgwave" 
                    width="100%" 
                    height="100%" 
                    xmlns="http://www.w3.org/2000/svg"
                    onMouseDown={handleMouseDown}
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseLeave}
                    style={{ cursor: isDragging ? 'grabbing' : 'grab' }}
                >
                    <path id="wavepath" d="M-400,59.580000000000005  L-400,59.580000000000005 S-133.20000000000002,149.58 0,149.58 S266.79999999999995,59.580000000000005 400,59.580000000000005 S666.8,149.58 800,149.58 S1066.8,59.580000000000005 1200,59.580000000000005 S1466.8,149.58 1600,149.58 S1866.8,59.580000000000005 2000,59.580000000000005"/>

                    <text textAnchor="middle">
                        <textPath 
                            ref={textPathRef}
                            id="my-text" 
                            className="my-text" 
                            href="#wavepath" 
                            startOffset={isAnimating ? undefined : `${currentOffset}%`}
                        >
                           PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »
                            PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »
                             PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »
                              PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »PRODUCTOS Y SERVICIOS » PRODUCTOS Y SERVICIOS »
                           {isAnimating ? (
                                <animate 
                                    ref={animateRef}
                                    attributeName="startOffset" 
                                    from="100%" 
                                    to="0%" 
                                    begin="0s"
                                    dur="30.5s" 
                                    repeatCount="indefinite" 
                                    calcMode="linear"
                                />
                           ) : null}
                        </textPath>
                    </text>
                </svg>
            </div>
        </div>
    );
};

export default WavyMarquee;